export const PRICE = {
  PAID_GAME_COST: 1,
  EDIT_GAME_COST: 3,
  CREATE_GAME_COST: 5
}
